module.exports = __webpack_public_path__ + "f8d9826257dececb302e871765e0fed0.jpg";